<template>
  <div class="calendar-container">
    <calendar-header
      :sourceType="searchParam.sourceType"
      :currentDate="currentDate"
      @openFilter="dialogVisible = true"
      @goToday="handleGoToday"
      @nextDate="handleNextDate"
      @previousDate="handlePreviousDate"
      @changeEventType="handleChangeEventType"
      @export="handleExport"
    ></calendar-header>
    <calendar-body
      ref="calendar-body"
      :currentMonthData="currentMonthData"
      :currentDate="currentDate"
      :update="callUpdate"
      @clickEvent="handleClickEvent"
    ></calendar-body>

    <el-dialog
      custom-class="filter-model"
      append-to-body
      title="Filter"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <filter-content
        :searchParam="{
          ideaCategory: searchParam.ideaCategory,
          schoolCode: searchParam.schoolCode,
          districtCode: searchParam.districtCode,
        }"
        @clear="handleClear"
        @filter="handleFilter"
      ></filter-content>
    </el-dialog>
  </div>
</template>

<script>
import calendarHeader from "./components/calendar-header";
import calendarBody from "./components/calendar-body";
import filterContent from "./components/filter-content";
export default {
  name: "jpcCalendar",
  components: {
    calendarHeader,
    calendarBody,
    filterContent,
  },
  props: {
    searchParam: {
      type: Object,
      default: () => {
        return {
          sourceType: [],
          ideaCategory: [],
          schoolCode: [],
          districtCode: "",
        };
      },
    },
    eventList: {
      type: Array,
      defaut: () => {
        return [];
      },
    },
  },
  watch: {
    eventList: {
      handler: async function () {
        await this.clearCurrentMonthEvent();
        await this.setCurrentMonthEventData();
        this.callUpdate = !this.callUpdate;
      },
      deep: true,
    },
  },
  data() {
    return {
      currentDate: null,
      yearMap: {},
      dialogVisible: false,
      callUpdate: false,
    };
  },
  computed: {
    currentMonthData() {
      if (!this.currentDate) return [];
      const currentYearList = this.yearMap[this.currentDate.year()];
      const previousMonthAddDay = this.currentDate.startOf("month").day(); //0是星期天 6是星期六
      let nextMonthAddDay = 6 - this.currentDate.endOf("month").day();
      if (
        previousMonthAddDay +
          nextMonthAddDay +
          currentYearList[this.currentDate.month()].length <
        42
      )
        nextMonthAddDay += 7;
      let previousMonthAddDayList = [];
      let nextMonthAddDayList = [];
      if (previousMonthAddDay > 0) {
        if (this.currentDate.month() == 0) {
          previousMonthAddDayList = this.yearMap[
            this.currentDate.year() - 1
          ][11].slice(0 - previousMonthAddDay);
        } else {
          previousMonthAddDayList = currentYearList[
            this.currentDate.month() - 1
          ].slice(0 - previousMonthAddDay);
        }
      }
      if (nextMonthAddDay > 0) {
        if (this.currentDate.month() == 11) {
          nextMonthAddDayList = this.yearMap[
            this.currentDate.year() + 1
          ][0].slice(0, nextMonthAddDay);
        } else {
          nextMonthAddDayList = currentYearList[
            this.currentDate.month() + 1
          ].slice(0, nextMonthAddDay);
        }
      }
      return [
        ...previousMonthAddDayList,
        ...currentYearList[this.currentDate.month()],
        ...nextMonthAddDayList,
      ];
    },
  },
  created() {
    this.currentDate = this.$dayjs();
    this.getYearMap(this.currentDate.year());
    this.setCurrentMonthEventData();
  },
  methods: {
    setCurrentMonthEventData() {
      const currentMonthEventList = this.eventList.filter((i) => {
        const startDate = this.$dayjs(i.startEventDate);
        const endDate = this.$dayjs(i.endEventDate);
        return (
          startDate.isSame(this.currentDate, "month") ||
          endDate.isSame(this.currentDate, "month") ||
          (startDate.isBefore(this.currentDate, "month") &&
            endDate.isAfter(this.currentDate, "month"))
        );
      });
      const sortEventList = this.$lodash.sortBy(currentMonthEventList, (i) => {
        return this.$dayjs(i.startEventDate).unix();
      });

      const currentYearList = this.yearMap[this.currentDate.year()];
      const currentMonthList = currentYearList[this.currentDate.month()];
      sortEventList.forEach((event) => {
        let location = 1;
        if (
          this.$dayjs(event.startEventDate).isSame(this.currentDate, "month")
        ) {
          const startDateItem = currentMonthList.find((date) => {
            return date.date.isSame(this.$dayjs(event.startEventDate), "date");
          });
          location = this.checkLocation(startDateItem, location);
          if (
            this.$dayjs(event.endEventDate).isSame(this.currentDate, "month")
          ) {
            for (
              let startIndex = startDateItem.date.date() - 1;
              startIndex < this.$dayjs(event.endEventDate).date();
              startIndex++
            ) {
              currentMonthList[startIndex].event[location] = event;
            }
          } else {
            for (
              let startIndex = startDateItem.date.date() - 1;
              startIndex <
              currentMonthList[currentMonthList.length - 1].date.date();
              startIndex++
            ) {
              currentMonthList[startIndex].event[location] = event;
            }
          }
        } else {
          location = this.checkLocation(currentMonthList[0], location);
          if (
            this.$dayjs(event.endEventDate).isSame(this.currentDate, "month")
          ) {
            for (
              let startIndex = currentMonthList[0].date.date() - 1;
              startIndex < this.$dayjs(event.endEventDate).date();
              startIndex++
            ) {
              currentMonthList[startIndex].event[location] = event;
            }
          } else {
            for (
              let startIndex = currentMonthList[0].date.date() - 1;
              startIndex <
              currentMonthList[currentMonthList.length - 1].date.date();
              startIndex++
            ) {
              currentMonthList[startIndex].event[location] = event;
            }
          }
        }
      });
    },
    checkLocation(startDateItem, location) {
      let resLocation = location;
      if (startDateItem.event[resLocation])
        return this.checkLocation(startDateItem, resLocation + 1);
      else return resLocation;
    },
    getDateListByMonth(monthDayJs) {
      let resList = [];
      const dateSum = monthDayJs.endOf("month").date();
      for (let i = 1; i <= dateSum; i++) {
        resList.push({
          date: monthDayJs.date(i),
          isHoliday: false,
          event: {},
          //key 位置  value Event
        });
      }
      return resList;
    },
    getMonthListByYear(yearDayJs) {
      let resList = [];
      for (let i = 0; i < 12; i++) {
        const currentMonthList = this.getDateListByMonth(yearDayJs.month(i));
        resList.push(currentMonthList);
      }
      return resList;
    },
    getYearMap(year) {
      const previousCurrentNextYearList = [year - 1, year, year + 1];
      previousCurrentNextYearList.forEach((i) => {
        if (!this.yearMap[i]) {
          this.yearMap[i] = this.getMonthListByYear(this.$dayjs().year(i));
        }
      });
    },
    handleNextDate() {
      if (this.currentDate.month() == 11) {
        this.getYearMap(this.currentDate.add(1, "year").year());
        this.currentDate = this.currentDate.add(1, "year").startOf("year");
      } else {
        this.currentDate = this.currentDate.add(1, "month");
      }
      this.$emit("changeMonth", { currentDate: this.currentDate });
    },
    handlePreviousDate() {
      if (this.currentDate.month() == 0) {
        this.getYearMap(this.currentDate.subtract(1, "year").year());
        this.currentDate = this.currentDate.subtract(1, "year").endOf("year");
      } else {
        this.currentDate = this.currentDate.subtract(1, "month");
      }
      this.$emit("changeMonth", { currentDate: this.currentDate });
    },
    handleGoToday() {
      this.currentDate = this.$dayjs();
      this.$emit("changeMonth", { currentDate: this.currentDate });
      this.clearCurrentMonthEvent();
      this.setCurrentMonthEventData();
    },
    clearCurrentMonthEvent() {
      const currentYearList = this.yearMap[this.currentDate.year()];
      const currentMonthList = currentYearList[this.currentDate.month()];
      currentMonthList.forEach((i) => {
        i.event = {};
      });
    },
    handleClear(e) {
      // TODO
      // this.changeFilter(e)
    },
    handleFilter(e) {
      this.dialogVisible = false;
      this.changeFilter(e);
    },
    changeFilter(e) {
      this.$emit("changeFilter", e);
      this.$emit("changeMonth", { currentDate: this.currentDate });
    },
    handleChangeEventType(e) {
      this.$emit("changeEventType", e);
      this.$emit("changeMonth", { currentDate: this.currentDate });
    },
    handleExport(e) {
      this.$emit("export", e);
    },
    handleClickEvent(e) {
      this.$emit("clickEvent", e);
    },
  },
};
</script>
<style lang="scss">
.filter-model {
  margin-top: 10vh !important;
  .el-dialog__body {
    padding: 10px 20px 30px;
  }
}
</style>
<style lang="scss" scoped>
.calendar-container {
  width: 100%;
  height: 100%;
}
</style>
